module.exports = __webpack_public_path__ + "static/media/queen_of_diamonds.cdc326c0.svg";